<template>
  <div class="home">
    <div class="main">
      <div class="item items">
        <van-field name="radio" label="是否本公司职工">
          <template #input>
            <van-radio-group
              v-model="forms.check"
              direction="horizontal"
              @change="getValue"
            >
              <van-radio name="1">是</van-radio>
              <van-radio name="2">否</van-radio>
            </van-radio-group>
          </template>
        </van-field>
      </div>
      <div class="item" v-if="forms.check == 1">
        <van-field
          v-model="fieldValue"
          is-link
          readonly
          label="所属部门"
          placeholder="请选择所属部门"
          @click="getDepart"
        />
        <van-popup v-model="show" round position="bottom">
          <van-cascader
            v-model="cascaderValue"
            title="请选择所属部门"
            :options="options"
            @close="show = false"
            @change="onChange"
            @finish="onFinish"
          />
        </van-popup>
      </div>
      <div class="item" v-if="forms.check == 2">
        <van-cell-group>
          <van-field
            v-model="forms.company"
            label="公司名称"
            placeholder="请输入公司名称"
          />
        </van-cell-group>
      </div>
      <div class="item">
        <van-cell-group>
          <van-field
            v-model="forms.name"
            label="姓名"
            placeholder="请输入姓名"
          />
        </van-cell-group>
      </div>
      <div class="item items">
        <van-field name="radio" label="性别">
          <template #input>
            <van-radio-group v-model="forms.sex" direction="horizontal">
              <van-radio name="0">男</van-radio>
              <van-radio name="1">女</van-radio>
            </van-radio-group>
          </template>
        </van-field>
      </div>
      <div class="item autoFlex">
        <van-cell plain type="primary"> 身份证号码 </van-cell>
        <van-field v-model="forms.personNo" />
        <!-- <van-number-keyboard v-model="forms.personNo" :show="showID" extra-key="X" close-button-text="完成"
					@blur="showID = false" @input="onInput" @delete="onDelete" /> -->
      </div>
      <div class="item autoFlex">
        <van-cell>手机号码</van-cell>
        <van-field v-model="forms.phoneNum" />
        <!-- <van-number-keyboard v-model="forms.phoneNum" :show="showPhone" :maxlength="11"
					@blur="showPhone = false" /> -->
      </div>
      <div class="item autoFlexNoJust" style="margin-top: 20px">
        <van-cell class="avatar">人脸照</van-cell>
        <van-uploader
          :before-delete="deleteEvent"
          :after-read="afterRead"
          :max-count="1"
          v-model="fileList"
          class="uploader"
        >
          <!-- <span>点击调用摄像头进行拍摄</span> -->
        </van-uploader>
      </div>
      <!-- <div class="item" style="display: flex;align-items: center;">
				<van-field v-model="forms.code" label="" placeholder="请输入验证码" />
				<van-button round type="info" size="normal" class='btns'>获取验证码</van-button>
			</div> -->
      <div class="item itemMargin tt">
        <!-- <van-checkbox-group v-model="result" direction="horizontal" ref="" @change="getCheck">
					<van-checkbox disabled :name="item" shape="square" v-for="(item, index) in authList" ref="checkbox"
						:key="index">{{ item.name }}</van-checkbox>
				</van-checkbox-group> -->
        <div class="namess">权限</div>
        <div class="rightLists">
          <span v-for="(iitem, index) in result" :key="index">{{
            iitem.name
          }}</span>
        </div>
      </div>
      <div class="item itemLength">
        <van-button
          round
          type="info"
          size="normal"
          class="btns"
          @click="userRegest"
          >保存</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import {
  regesterUser,
  getDepartments,
  getAuth,
  uploadImg,
  queryPersonalInfo,
  saveUserInfo,
} from "../apis/api.js";
export default {
  data() {
    return {
      result: [],
      fileList: [],
      isChecked: true,
      isCheckeds: false,
      showID: false,
      belongParts: "请选择所属部门",
      show: false,
      showPhone: false,
      fieldValue: "",
      forms: {
        name: "",
        sex: "1",
        check: "1",
        code: "",
        phoneNum: "",
        personNo: "",
        company: "",
      },
      cascaderValue: "",
      options: [],
      iscompany: 1,
      authList: [],
      checkedAuth: [],
      departId: "",
      personImg: "",
      infos: {},
      apiLists: [],
      checkedAuthList: [],
    };
  },
  mounted() {
    document.title = "修改个人信息";
    this.getAuths();
    this.querInfos();
  },
  methods: {
    deleteEvent(value) {
      console.log(value);
      this.personImg = "";
      return true;
    },
    querInfos() {
      // 查询个人信息
      queryPersonalInfo({}).then((res) => {
        this.infos = res.result;
        console.log(this.infos.authorityList, "=====");
        this.forms.name = this.infos.personName;
        this.forms.sex = String(this.infos.personSex);
        this.forms.check = this.infos.departId.length > 2 ? "1" : "2";
        this.forms.personNo = this.infos.personNo;
        this.forms.phoneNum = this.infos.phoneNum;
        this.forms.company = this.infos.companyName;
        console.log(this.infos, "-------");
        this.apiLists = this.infos.authorityList;
        this.result = this.infos.authorityList;
        this.personImg = this.infos.personImg;

        let id = this.infos.departId;
        this.fileList.push({
          url: this.infos.personImg,
        });
        getAuth({
          iscompany: this.infos.departId.length > 2 ? "1" : "0",
        }).then((res) => {
          console.log(res.result);
          this.apiLists = res.result;
          this.infos.authorityList.forEach((item, i) => {
            this.apiLists.forEach((iitem) => {
              console.log("1", iitem.id, item.id);
              if (item.authority == 1) {
                this.checkedAuthList.push(item);
              }
              if (item.id == iitem.id && item.authority == 1) {
                this.$refs.checkbox[i].toggle(true);
              } else {
                return;
              }
            });
          });
        });

        getDepartments().then((xhr) => {
          this.options = xhr.result.map((item) => {
            if (item.departList.length > 0) {
              item.children = item.departList;
              item.children.forEach((iitem) => {
                iitem.text = iitem.departName;
                iitem.value = iitem.id;
              });
            }

            item.text = item.departName;
            item.value = item.id;
            return item;
          });
          console.log("分割线", this.options);
          this.options.forEach((item) => {
            if (item.departList.length > 0) {
              item.departList.forEach((iitem) => {
                console.log("走这里", id, iitem.id);
                if (iitem.id == id) {
                  this.fieldValue = item.departName + "/" + iitem.departName;
                  this.departId = iitem.id;
                }
              });
            } else {
              console.log("走这里123", id, item.id);
              if (item.id == id) {
                this.fieldValue = item.departName;
                this.departId = item.id;
              }
            }
          });
        });
      });
    },
    onOversize(file) {
      console.log(file);
      Toast("文件大小不能超过 500kb");
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      console.log(file);
      file.status = "uploading";
      file.message = "上传中...";
      uploadImg({
        img: file.content,
        openId: localStorage.getItem("openId"),
        ext: file.file.name.split(".")[1],
      }).then((res) => {
        console.log(res);
        Toast("上传成功");
        this.personImg = res.result.savePath;
        file.status = "done";
        file.message = "上传成功";
      });
    },
    getCheck(item) {
      item.forEach((iitem) => {
        iitem.authority = 1;
      });

      this.checkedAuth = item;

      //   数组去重
      let obj = {};
      this.checkedAuth = this.checkedAuth.reduce(function (item, next) {
        obj[next.id] ? "" : (obj[next.id] = true && item.push(next));
        return item;
      }, []);
    },
    getValue(value) {
      if (value == 1) {
        this.iscompany = 1;
      } else {
        this.iscompany = 0;
      }

      this.getAuths();
    },
    getAuths() {
      getAuth({
        iscompany: this.iscompany,
      }).then((res) => {
        console.log(res.result);
        this.authList = res.result;
      });
    },
    getDepart() {
      this.show = true;
      getDepartments().then((res) => {
        console.log(res);
        this.options = res.result.map((item) => {
          item.text = item.departName;
          item.value = item.id;
          if (item.departList.length > 0) {
            item.children = item.departList;
            item.children.forEach((iitem) => {
              iitem.text = iitem.departName;
              iitem.value = iitem.id;
            });
          }

          return item;
        });
      });
    },
    userRegest() {
      if (this.forms.name == "") {
        this.$toast("请输入姓名");
      } else if (this.forms.phoneNum == "") {
        this.$toast("请输入手机号码");
        if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(phone)) {
          this.$toast("手机号码格式不正确");
        }
      } else if (this.forms.personNo == "") {
        this.$toast("请输入身份证号码");
      } else if (this.personImg == "") {
        this.$toast("请上传人脸照");
      } else {
        var obj = {};
        this.checkedAuth = this.checkedAuth.reduce(function (item, next) {
          obj[next.id] ? "" : (obj[next.id] = true && item.push(next));
          return item;
        }, []);
        // console.log(this.checkedAuth);
        saveUserInfo({
          personName: this.forms.name,
          phoneNum: this.forms.phoneNum,
          personNo: this.forms.personNo,
          personSex: this.forms.sex,
          departId: this.forms.check == 2 ? "-2" : this.departId,
          companyName: this.forms.company,
          authorityList: this.checkedAuth,
          openId: localStorage.getItem("openId") || "",
          personImg: this.personImg,
          uid: this.infos.uid,
        }).then((res) => {
          Toast("更新成功");
          this.$router.push("/personal");
          //    this.$router.push("/personal")
        });
      }
    },
    onInput(value) {
      console.log(value);
    },
    onDelete() {},
    onChange({ value }) {},
    onFinish({ selectedOptions }) {
      console.log(selectedOptions);
      this.show = false;
      this.fieldValue = selectedOptions.map((option) => option.text).join("/");
      this.departId = selectedOptions.pop().value;
    },
    onSubmit(values) {
      console.log("submit", values);
    },
    checkoutYes() {
      console.log("yes");
      this.isChecked = true;
      this.isCheckeds = false;
    },
    checkoutNo() {
      this.isChecked = false;
      this.isCheckeds = true;
      console.log("no");
    },
  },
};
</script>

<style lang="less" scoped>
.itemLength {
  width: 100%;
  margin-top: 30px;
  text-align: center;

  .btns {
    // width: 100%;
    height: 80px;
    width: 70%;
  }
}

.btns {
  width: 50%;
  height: 60px;
}

.home .avatar::after {
  border: none;
}

.home .avatar {
  width: 20% !important;
}

.home {
  background: url(../assets/regest/bg.jpg) no-repeat;
  background-size: 100% 100%;
  min-height: 100vh;
  width: 100%;
}

.itemMargin {
  margin-top: 30px;
}

.banner {
  width: 100vw;

  img {
    width: 100vw;
    height: 340px;
    // margin-top: 100px;
  }
}

.top {
  display: flex;
  padding: 40px 20px;

  .close_btn {
    font-size: 40px;
  }

  span {
    font-size: 32px;
    // font-weight: bold;
    color: #333;
  }
}

.main {
  padding: 0 30px;

  .items {
    border-bottom: 1px solid #ebedf0;
    // padding-bottom: 20px;
    // margin-top: 30px;
  }

  .item {
    .label {
      // margin-right: 30px;
      width: 220px;

      font-size: 26px;
    }

    .align_right {
      margin-right: 80px;

      img {
        margin-right: 10px;
      }
    }
  }
}
.tt {
  display: flex;
  align-items: center;
  .namess {
    font-size: 24px;
    display: inline-block;
    width: 100px;
  }
  span {
    font-size: 24px;
    display: inline-block;
    width: 20%;
    margin-bottom: 10px;
  }
  .rightLists {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
}
</style>
